/**
 * Search request — query parameters for Bible text search.
 */
import { z } from 'zod';
export const SearchRequestSchema = z.object({
    text: z.string().min(1),
    isExact: z.boolean().default(false),
    testament: z.number().optional(),
    bookNumber: z.number().optional(),
    limit: z.number().default(20),
    offset: z.number().default(0),
});
//# sourceMappingURL=search-request.js.map